import { render, staticRenderFns } from "./ProductGroupEditProperties.vue?vue&type=template&id=2bc78b2b&scoped=true"
import script from "./ProductGroupEditProperties.vue?vue&type=script&lang=ts"
export * from "./ProductGroupEditProperties.vue?vue&type=script&lang=ts"
import style0 from "./ProductGroupEditProperties.vue?vue&type=style&index=0&id=2bc78b2b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc78b2b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bc78b2b')) {
      api.createRecord('2bc78b2b', component.options)
    } else {
      api.reload('2bc78b2b', component.options)
    }
    module.hot.accept("./ProductGroupEditProperties.vue?vue&type=template&id=2bc78b2b&scoped=true", function () {
      api.rerender('2bc78b2b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/product-group/ProductGroupEditProperties.vue"
export default component.exports